<template>
	<div class="zhanlan-main"  @click="showSliber=false">
    <div class="posdiv">
        <topnav />
        <!--展览-->
        <div class="searchwarp">
          <img src="../assets/three.svg" @click.stop="showSliber = !showSliber">
          <input type="search" v-model="keyword" @keyup.enter="submit" v-on:input="submit">
        </div>
    </div>

    <div class="test"  v-show="dataFlag">
      <ul  v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" class="zlul">
        <li class="zhanlan" :class="{ showSliber: showSliber }" v-for="item in zhanlanData" :key="item.id">
          <router-link :to="{path:'/zhanlanDetail',query: {id: item.id}}">
            <img :src="item.pictureId" >
            <div class="infowarp ">
              <div class="title ellipse">{{item.headline}}</div>
              <div class="addr ellipse">{{item.openAddress}}</div>
              <div v-if="item.exhibitionType == 1" class="info changshe ellipse">常设</div>
              <div v-if="item.exhibitionType == 0" class="time ellipse">{{item.beginTime}}-{{item.endTime}}</div>
              <div v-if="item.exhibitionType == 0 && item.day == '已结束'" class="info ellipse">已结束</div>
              <div v-if="item.exhibitionType == 0 && item.day != '已结束'" class="info ellipse">还有{{item.day}}天结束</div>
            </div>
          </router-link>
        </li>
        <li v-if="footloadmore" class="footloadmore">
          <img src="../assets/a.gif" >
        </li>
      </ul>
    </div>

    <noData  v-if="!dataFlag"></noData>
    <!--侧边栏-->
    <div class="sliberwarp" v-if="showSliber">
      <div class="item"  :class="{'itemactive':index == cur }" v-for="(item,index) in sliberData" :key="item.id" @click="clickitem(index,item.id)">
        {{item.name}}
      </div>
    </div>
	</div>
</template>

<script>
  import { Indicator } from 'mint-ui';
  import topnav from '../components/topnav.vue';
  import {api} from '../global/api';
  import noData from './noData';
	export default {
		data () {
		    return {
          showSliber:false,
          cur:0,
//          sliberData:["东城区","西城区","朝阳区","丰台区","通州区"],
          sliberData:[],
          zhanlanData:[],
          loading:true,
          size:5,
          currentPage:1,
          keyword:'',
          footloadmore:false,
          dataFlag:true,
          curId:""
		    }
		},
    components :{
      topnav,
      noData
    },
    mounted(){
      this.getSliber();
     // this.getZhanlan(false,this.curId);
      $(".footmenu li").eq(0).addClass('router-link-exact-active').addClass('router-link-active')

		},
		methods:{
      loadMore(){
        console.log("触发了");
        this.loading = true;
        this.currentPage ++;
        this.getZhanlan(true);
        // 多次加载数据
        // setTimeout(() => {
        //   this.currentPage ++;
        //   this.getZhanlan(true);
        // }, 1000);
      },
      clickitem(index,id){
        this.loading = true;
        this.cur = index;
        this.curId=id
        this.showSliber = !this.showSliber;
        this.currentPage=1;
        this.getZhanlan(false,id);
      },
      submit(){
         this.loading = true;
        this.currentPage=1;
        this.getZhanlan(false,this.curId);
      },

      getZhanlan(flag,id) {
        if(flag){
            this.footloadmore = true;
        }else{
          Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        }
        const params = {size:this.size,currentPage:this.currentPage,area:this.curId,key:this.keyword};
        this.loading = true;
        this.$http.get(api.zhanlan, {params:params}).then(response => {
          let { success,data }=response.data;
          if(success === 1){
            if(flag){
              // 多次加载数据
              this.zhanlanData = this.zhanlanData.concat(data);
              if(data.length == 0){
                this.loading = true;
              }else{
                this.loading = false;
              }
              this.footloadmore = false;
            }else{
              // 第一次加载数据
              this.zhanlanData = data;
              Indicator.close();
              this.loading = false;
              if(data.length <= 0){
                  this.dataFlag=false;
                  this.loading = true;
              }else{
                this.dataFlag = true;
                this.loading = false;
              }
            }
          }else{
            console.log("接口异常");
          }
          }, response => {
              console.log("请求失败了");
            })
        },
      getSliber(){
        this.$http.get(api.arealist ).then(response => {
          let { success,data }=response.data;
          if(success === 1){
            this.sliberData = data;
            this.curId=this.sliberData[0].id;
            this.getZhanlan(false,this.curId);
          }else{
            console.log("接口异常");
          }
          }, response => {
              console.log("请求失败了");
            })
      }
		}

	}
</script>
<style lang="scss" scoped="">
  .zhanlan-main{
    position: relative;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
  }
  .posdiv{
    width: 100%;
    position: fixed;
    top:0;
    background-color: #ffffff;
    height: 5rem;
    z-index: 110;
    // border: 1px solid red;
  }
  /*展览tab*/
  .searchwarp{
    padding: 0 0.75rem;
    margin-bottom:0.85rem;
    display: flex;
    justify-content: space-between;
    input{
      // float: right;
      margin-left: 0.5rem;
      box-sizing: border-box;
      width: 15.25rem;
      height:1.5rem;
      border-radius: 0.5rem;
      border: none;
      padding-left: 1.5rem;
      background:#F1F1F2 url("../assets/searchbtn.svg") no-repeat 0.5rem center;
    }
  }
  ::-webkit-search-cancel-button { display: none; }
  .zlul{
    margin-bottom: 3.5rem;
    margin-top: 5rem;
  }
  .sliberwarp{
    position: fixed;
    top:5.1rem;
    left: 0;
    width: 6rem;
    max-height:23rem;
    overflow-y: auto;
    padding-bottom: 1rem;
    background: #F1F1F2;
    .item{
      width: 6rem;
      height: 2.2rem;
      line-height: 2.2rem;
      text-align: center;
      font-size: 0.7rem;
      color: #333333;
    }
    .itemactive{
      background-color: #C44D41;
      color: #ffffff;
    }
  }
  .showSliber{
    position: relative;
    left: 6rem;
  }

  .zhanlan{
    margin: 0 0.75rem 0.5rem;
    padding: 0.75rem 0 0.75rem 0.75rem;

    border-radius: 0.5rem;
    background-color: rgba(241, 241, 242, 1);

    img{
      display: inline-block;
      width: 6rem;
      height: 4.5em;
      margin-right: 0.5rem;
    }
    .infowarp{
      width: 9rem;
      vertical-align: top;
      display: inline-block;
      .title{
        margin-top: 0.25rem;
        color: rgba(51, 51, 51, 1);
        font-size: 0.7rem;
        text-align: left;
        font-family: PingFang-SC-Regular;
      }
      .addr{
        margin-top: 0.45rem;
        color: rgba(153, 153, 153, 1);
        font-size: 0.65rem;
        text-align: left;
        font-family: PingFang-SC-Regular;

      }
      .time{
        margin-top: 0.25rem;
        color: rgba(153, 153, 153, 1);
        font-size: 0.65rem;
        text-align: left;
        font-family: PingFang-SC-Regular;

      }
      .info{
        margin-top: 0.25rem;
        color: rgba(196, 77, 65, 1);
        font-size: 0.65rem;
        text-align: left;
        font-family: PingFang-SC-Bold;

      }
      .changshe{margin-top: 1.1rem}
    }
  }
  .ellipse{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .footloadmore{
    width: 100%;
    display: inline-block;
    text-align: center;
    img{
      width: 8rem;
    }

  }
</style>



// WEBPACK FOOTER //
// src/view/zhanlan.vue